import { AfterViewInit, Component, OnDestroy, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

import { MainMenuComponent } from '../../shared/main-menu/main-menu.component';
import { SubscribeComponent } from '../../shared/subscribe/subscribe.component';
import { AboutMenuComponent } from '../../shared/about-menu/about-menu.component';
import { ScriptLoaderService, VENDOR_SCRIPTS } from '../../script-loader.service';
import { ManagementProfile } from '../../shared/models/management.model';
import { extractManagementProfiles } from '../services/management-profiles-response.util';

@Component({
  selector: 'app-balaji-insurance',
  standalone: true,
  imports: [CommonModule, RouterLink, MainMenuComponent, SubscribeComponent, AboutMenuComponent],
  templateUrl: '../templates/balaji-insurance.component.html'
})
export class BalajiInsuranceComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly profile = signal<ManagementProfile | null>(null);

  constructor(private readonly scriptLoader: ScriptLoaderService) { }

  ngOnInit(): void {
    this.loadProfile();
  }

  ngAfterViewInit(): void {
    document.body.classList.add('defult-home');
    this.scriptLoader
      .loadSequential(...VENDOR_SCRIPTS)
      .then(() => {
        // If vendor scripts were injected after the native load event,
        // re-dispatch it so jQuery load handlers in main.js still run.
        if (document.readyState === 'complete') {
          window.dispatchEvent(new Event('load'));
        }
      })
      .catch((error) => {
        console.error('Failed to load third-party scripts', error);
      });
  }

  ngOnDestroy(): void {
    document.body.classList.remove('defult-home');
  }

  private async loadProfile(): Promise<void> {
    try {
      const response = await fetch('https://api.sbesatp.org/v1/web/management-profiles');
      if (!response.ok) {
        throw new Error(`Failed to load management profiles: ${response.status}`);
      }

      const profiles = extractManagementProfiles(await response.json());
      const profile = profiles.find(p => p.id === 'insurance');
      this.profile.set(profile || null);
    } catch (error) {
      console.error('Failed to load management profiles JSON', error);
      this.profile.set(null);
    }
  }
}

